document.addEventListener('DOMContentLoaded', function () {

  var BASE_PRICE = 26.00;
  var MAX_CHARS = 25;

  function getTierPrice(charCount) {
    if (charCount <= 0)  return BASE_PRICE;
    if (charCount <= 5)  return BASE_PRICE;
    if (charCount <= 10) return BASE_PRICE + 6;
    if (charCount <= 15) return BASE_PRICE + 12;
    if (charCount <= 20) return BASE_PRICE + 18;
    if (charCount <= 25) return BASE_PRICE + 24;
    return BASE_PRICE + 24;
  }

  function initCharacterPricing() {
    var input = document.querySelector('input[name="properties[Personalization]"]');
    if (!input) return;

    // --- Character counter ---
    var counter = document.createElement('div');
    counter.id = 'io-char-counter';
    counter.style.cssText = 'font-size:13px; color:#888; margin-top:6px;';
    counter.textContent = '0/' + MAX_CHARS + ' characters';
    input.parentNode.insertBefore(counter, input.nextSibling);

    // --- Enforce max (no spaces counted) ---
    input.addEventListener('input', function () {
      var withoutSpaces = this.value.replace(/ /g, '');

      // If non-space chars exceed max, trim input
      if (withoutSpaces.length > MAX_CHARS) {
        // Remove characters from the end until we're within limit
        var trimmed = '';
        var count = 0;
        for (var i = 0; i < this.value.length; i++) {
          if (this.value[i] === ' ') {
            trimmed += ' ';
          } else if (count < MAX_CHARS) {
            trimmed += this.value[i];
            count++;
          }
        }
        this.value = trimmed;
        withoutSpaces = this.value.replace(/ /g, '');
      }

      counter.textContent = withoutSpaces.length + '/' + MAX_CHARS + ' characters';
    });

    // --- Update price on blur (click away) ---
    input.addEventListener('blur', function () {
      var charCount = this.value.replace(/ /g, '').length;
      var newPrice = getTierPrice(charCount);

      var priceEls = document.querySelectorAll('.price-item--regular');
      priceEls.forEach(function (el) {
        el.textContent = '$' + newPrice.toFixed(2);
      });
    });
  }

  // Infinite Options loads dynamically, so we wait for it
  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    var input = document.querySelector('#infiniteoptions-container input[type="text"]');
    if (input) {
      clearInterval(interval);
      initCharacterPricing();
    }
    if (attempts > 20) clearInterval(interval);
  }, 300);

});